import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { AnimationItem } from 'lottie-web'
import { lottie as $lottie } from 'src/boot/lottie'
import { ref, onBeforeUnmount, onMounted, toValue, Ref, shallowRef, watch } from 'vue'

interface IProps {
  name: string
  autoplay?: boolean
  loop?: boolean
  speed?: number
  width?: string | null
}

type Emit = { animation: [animationItem: AnimationItem] }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseLottie' },
  __name: 'BaseLottie',
  props: {
    name: {},
    autoplay: { type: Boolean, default: true },
    loop: { type: Boolean, default: true },
    speed: { default: 1 },
    width: { default: null }
  },
  emits: ["animation"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v157022f4": (widthRef.value)
}))



const props = __props
const emit = __emit

const lottieRef: Ref<Element | null> = ref(null)
const animation = shallowRef<AnimationItem | null>(null)
const widthRef: Ref<string> = ref(toValue(() => props.width) ?? '100%')

onMounted(() => {
  const container = lottieRef.value
  if (container) {
    animation.value = $lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: props.loop,
      autoplay: props.autoplay,
      path: `/lottie-files/${props.name}.json`,
      name: props.name,
    })

    animation.value.setSpeed(props.speed)
    emit('animation', animation.value)
  }
})

watch(
  () => props.speed,
  (speed) => {
    animation.value?.setSpeed(speed)
  },
)

onBeforeUnmount(() => {
  animation.value?.destroy()
  animation.value = null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    ref_key: "lottieRef",
    ref: lottieRef,
    class: "flex flex-center lottie-wrapper"
  }, null, 512 /* NEED_PATCH */))
}
}

})